import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalDatasetPageRoutingModule } from './modal-dataset-routing.module';

import { ModalDatasetPage } from './modal-dataset.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalDatasetPageRoutingModule
  ],
  declarations: [ModalDatasetPage]
})
export class ModalDatasetPageModule {}
